<template>
<div class="delivery-card" :style="{ paddingBottom: concise ? '0px' : '' }">
  <div class="delivery-box" v-show="delivery?.shippingTimeDescription">
    <div class="delivery-title">
      <img class="icon" :src="$cvWebpFn(supportedIcon?.icon || useImg1pxBase64().value, { w: 60 })">
      <span :style="{ color: supportedIcon?.color, fontWeight: 700 }">{{ supportedIcon?.title }}</span>
    </div>
    <div class="delivery-content">
      <ul>
        <!-- 老的时效， 注释掉
        <li v-for="(info, index) in (delivery?.info || [])" :key="index" v-html="info" /> -->
        <div v-if="delivery?.shippingTimeDescription" v-html="delivery?.shippingTimeDescription" />
      </ul>
    </div>
  </div>

  <div class="return-policy" v-if="!concise">
    <a v-if="!isNewAfterSale" :href="returnPolicySrc" target="_blank">
      <div class="policy-item">
        <p class="policy-title">
          <span>
            <img :src="$cvWebpFn('https://image.kilimall.com/c/h5/imgs/ic_return_policy@2x.png', { w: 60 })" alt="">
            Return Policy
          </span>

          <span class="icon"><van-icon name="arrow" size="14" /></span>
        </p>
        <p class="tips tips-box">Easy Return, Quick Refund</p>
      </div>
    </a>
    <div v-else>
      <div class="policy-item">
        <p class="policy-title">
          <span>
            <img :src="$cvWebpFn('https://image.kilimall.com/c/h5/imgs/ic_return_policy@2x.png', { w: 60 })" alt="">
            Warranty Options
          </span>
          <!-- <span class="icon"><van-icon name="arrow" size="14" /></span> -->
        </p>
        <div class="warranty-tags">
          <template v-if="displayWarrantyTags.length">
            <span
              v-for="(tag, idx) in displayWarrantyTags"
              :key="idx"
              class="tag"
            >
              {{ tag }}
            </span>
          </template>
          <a class="all-details" :href="returnPolicySrc" target="_blank">
            All details at <span>Return Policy</span>
          </a>
        </div>
      </div>
    </div>

    <div class="policy-item">
      <a href="/help-center/oh_3509?s_id=1004&bs_type=1&c_id=1086" target="_blank">
        <p class="policy-title">
          <span>
            <img :src="$cvWebpFn('https://image.kilimall.com/c/h5/imgs/ic_shopping_security@2x.png', { w: 60 })" alt="">
            Shopping Security
          </span>

          <span class="icon"><van-icon name="arrow" size="14" /></span>
        </p>
        <ul class="tips-box">
          <li class="tips li">Safe Payments</li>
          <li class="tips li">Secure Logistics</li>
          <li class="tips li">Secure Privacy</li>
          <li class="tips li">Purchase Protection</li>
        </ul>
      </a>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { getWarrantyTagsBySnapshot } from '@/plugins/after-sale.client'
import { getAfterSaleEntryConfigApi } from '@/api/models/new-after-sale'
type IDeliveryInfo = Partial<ProductV3.ShippingTime & ProductV3.AftersaleCommitment>
const props = defineProps<{ delivery?: IDeliveryInfo; concise?: boolean; warrantyTags?: string[] }>()

interface ISupportedIcon { icon: string, title: string, color: string }

const isNewAfterSale = ref(false)

const initAfterSaleEntry = async () => {
  try {
    const res: any = await getAfterSaleEntryConfigApi()
    isNewAfterSale.value = res.afterSalesEntry === 'new'
  } catch (error) {
    console.error('getAfterSaleEntryConfigApi error', error)
    isNewAfterSale.value = false
  }
}

onMounted(() => {
  initAfterSaleEntry()
})

const displayWarrantyTags = computed(() => {
  if (props.warrantyTags?.length) {
    return props.warrantyTags
  }

  if (!props.delivery) {
    return []
  }
  const delivery = props.delivery
  return getWarrantyTagsBySnapshot(
    {
      exchangePeriod: delivery.exchangePeriod,
      returnRefundPeriod: delivery.returnRefundPeriod,
      warrantyPeriod: delivery.warrantyPeriod,
      noReasonReturnRefund: delivery.support7daysReturn,
    },
    { logisticsType: delivery.logisticsType },
    true
  ).tags
})

const supportedIcon = computed<ISupportedIcon | undefined>(() => {
  if(props.delivery?.logisticsType === 'fbk') {
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_fbk.png'
    let color = '#f87724'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_fulfilled_by_kilimall.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Fulfilled By Kilimall', color: color }
  }

  if(props.delivery?.logisticsType === 'gs'){
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_gs.png'
    let color = '#7054a1'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_oversea_shipment.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Oversea Shipment', color: color }
  }

  if(props.delivery?.logisticsType === 'ds'){
    let iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_details_logistics_drop.png'
    let color = '#45b75d'
    if (isFacebook().value || isTiktok().value || isWhatsApp().value) {
      iconUrl = 'https://image.kilimall.com/c/h5/imgs/ic_local_dispatch.png'
      color = '#030303'
    }
    return { icon: iconUrl, title: 'Local Dispatch', color: color }
  }
})

const returnPolicySrc = computed<string>(() => {
  if(props.delivery?.logisticsType === 'fbk') {
    return '/help-center/oh_3507?s_id=1004&bs_type=1&c_id=1098'
  }

   if(props.delivery?.logisticsType === 'gs'){
    return '/help-center/oh_3504?s_id=1004&bs_type=1&c_id=1098'
  }

  if(props.delivery?.logisticsType === 'ds'){
    return '/help-center/oh_3506?s_id=1004&bs_type=1&c_id=1098'
  }

  return '/help-center/oh_3348?s_id=1004&bs_type=1&c_id=1083'
})
</script>

<style lang="scss" scoped>
.delivery-card{
  padding-bottom: 10px;
  .delivery-box{
    min-height: 122px;
  }
  .delivery-title{
    display: flex;
    align-items: center;
    color: #f76900;
    font-size: 30px;
    margin-bottom: 8px;
    .icon{
      height: 50px;
      width: 50px;
      min-width: 50px;
      margin-right: 10px;
    }
  }
  .delivery-content{
    padding-left: 50px;
    font-size: 24px;
  }
}

.return-policy{
  .policy-item{
    margin: 40px 0 10px 0;
    .policy-title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      height: 50px;
      img{ height: 40px; width: 40px;margin-right: 10px; };
      span{ display: flex; align-items: center }
    }
    .icon{color:#b1b1b1;font-size: 22px;text-shadow: none;}
    .tips{
      color: #666;
      font-size: 24px;
    }
    .warranty-tags {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      row-gap: 20px;
      margin-top: 10px;
      .all-details {
        margin-left: auto;
        color: #666;
        span {
          color: #255af0;
        }
      }
      .tag {
        display: inline-block;
        border-radius: 2px;
        padding: 0 6px;
        font-size: 20px;
        font-weight: 500;
        margin: 0 8px 0 0;
        background-color: rgba(68, 179, 91, 0.2);
        color: #44b35b;
      }
    }
    .tips-box{
      padding-left: 50px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      .li{
        width: 50%;
        margin: 5px 0;
        display: flex;
        align-items: center;
        &::before{
          content: "";
          height: 4px;
          width: 4px;
          background: #666;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>